import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import {
  ShipmentWaybillDemurrageAndDetentionInfoLoad,
  ShipmentWaybillDemurrageAndDetentionInfoSetInitialState,
} from './shipment-waybill-demurrage-and-detention-info.actions';
import { ShipmentWaybillDemurrageAndDetentionInfoState } from './shipment-waybill-demurrage-and-detention-info.state';
import {
  ShipmentWaybillDemurrageAndDetentionContainer,
  ShipmentWaybillDemurrageAndDetentionSummary,
} from '../../models';
@Injectable({ providedIn: 'root' })
export class ShipmentWaybillDemurrageAndDetentionInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillDemurrageAndDetentionInfoState.getLoaded);
  summary$: Observable<ShipmentWaybillDemurrageAndDetentionSummary> = this.store.select(
    ShipmentWaybillDemurrageAndDetentionInfoState.getSummary,
  );
  origin$: Observable<ShipmentWaybillDemurrageAndDetentionContainer> = this.store.select(
    ShipmentWaybillDemurrageAndDetentionInfoState.getOrigin,
  );
  destination$: Observable<ShipmentWaybillDemurrageAndDetentionContainer> = this.store.select(
    ShipmentWaybillDemurrageAndDetentionInfoState.getDestination,
  );

  constructor(private store: Store) {}

  loadAll(internalWaybillId: string): void {
    this.store.dispatch(new ShipmentWaybillDemurrageAndDetentionInfoLoad(internalWaybillId));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillDemurrageAndDetentionInfoSetInitialState());
  }
}
